module.exports = __webpack_public_path__ + "static/media/System_Setup.7d3a541e.svg";